import { PropsWithChildren } from 'react';

import cn from 'classnames';

import type { BaseComponentProps } from '../../../../types/common';

import styles from './styles.module.css';

export interface CardContentProps extends BaseComponentProps {
  /**
   * The layout of the card.
   */
  className?: string;
  /**
   * The children of the CardContent component.
   */
  children: PropsWithChildren['children'];
}

/**
 * Content section of the Card component.
 * Wraps the main content of the card.
 */
export const CardContent: React.FC<CardContentProps> = ({
  children,
  dataTestId,
  className,
}) => {
  return (
    <div
      className={cn(styles['card-content'], className)}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
};
